module.exports = new __parcel__URL__("NABP-certified.f41fbd43.png").toString();